export class VehicleTypeConstants {
  static readonly AUTO = 'vehicle';
  static readonly CYCLE = 'cycle';
  static readonly RV = 'recreational vehicle';
  static readonly WATERCRAFT = 'watercraft';
}
